
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-and-news/[category]",
      function () {
        return require("private-next-pages/blog-and-news/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-and-news/[category]"])
      });
    }
  